import { Grid } from "@mui/material";
import React from "react";
import JInvoiceHeader from "./home/header";
import JInvoiceTable from "./home/table";


const JInvoices = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <JInvoiceHeader />
      </Grid>
      <Grid item xs={12}>
        <JInvoiceTable />
      </Grid>
    </Grid>
  );
};

export default JInvoices;
